import React, { Component } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import {Const} from '../stores/Constants';
import { store } from '../stores/mainStore';
import {B64Image} from '../components/B64Image';

const ButtonMoverBody = styled.div`
	user-select: none;
	line-height: 0;
	-webkit-appearance: none;
	box-shadow: none !important;
	position: relative;
	& * {
		pointer-events: none;
	}
	filter: ${p => p.disable ? 'grayscale(1)' : 'none'};
	pointer-events: ${p => p.disable ? 'none' : 'inherit'};
`;

export class ButtonMover extends Component {
	state = {
		pointerCount: 0,
	};

	up = () => {
		this.setState({ pointerCount: this.state.pointerCount + 1 });
	};

	down = () => {
		if (this.state.pointerCount) {
			this.setState({ pointerCount: this.state.pointerCount - 1 });
		}
	};

	componentWillUnmount() {
		// this.ref.style.display = 'none';
	}

	render() {
		// console.log(this.state.pointerCount);
		var { style, block, ...rest } = this.props;
		style = style || {};
		//style.top = this.state.pointerCount ? 4 : 0;

		return (
			<ButtonMoverBody
				{...rest}
				onPointerDown={this.up}
				onPointerUp={this.down}
				onPointerOut={this.down}
				style={style}
				// ref={(ref) => {
				// 	this.ref = ref;
				// }}
			>
				{this.props.children}
			</ButtonMoverBody>
		);
	}
}

export const ButtonIcon = styled(p => {return (
	<div className={`btnIcon ${p.className}`} id={p.id} style={p.style}>
		<B64Image alt="button icon" src={p.src} style={p.style}/>
		<div className='inner'>
			{p.children}
		</div>
	</div>
)})`
	img {
		height: 100%;
		visibility:hidden;
	}
	background: url(${p => p.src}) center/contain no-repeat;
	${p => p.w ? `
		width: ${p.w} !important;
		max-width: inherit !important;
	` : ''}
	${p => p.h ? `height: ${p.h} !important;` : ''}
	${p => p.hide ? 'visibility: hidden;' : ''}
	${p => p.absolute ? `
		position: absolute;
		${p.top ? `top: ${p.top};` : ''}
		${p.left ? `left: ${p.left};` : ''}
		${p.right ? `right: ${p.right};` : ''}
	` : `
		margin-right: 1vw;
		position: relative;
		${p.left ? `left: ${p.left};` : ''}
	`}

	.inner {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		display:flex;
		justify-content: center;
		align-items: center;
	}
`;

export const Button = styled(p => { return (
	<div className={p.className} onClick={p.onClick} style={p.style}>
		{p.glow && <motion.div className='glow'
			initial={{opacity: 0}}
			animate={{opacity: 1}}
			transition={{duration: 1, yoyo:Infinity}}
		/>}
		<div className='bottom'>
			<div className='top'>
				{ typeof(p.children) !== 'string' ?
					!p.children.length ? p.children :
					p.children.map((ch,i) => typeof(ch) !== 'string' ? ch :
						<div className='label' key={'lb'+i}>{ch}</div>
					) : 
						<div className='label'>{p.children}</div>
				}
			</div>
		</div>
	</div>
)})` ${p => {
	const disabled = p.disable ? p.disable : false;
	const schemes = Const.BUTTON_SCHEME;
	const color = schemes[disabled ? 'grey' : p.color ? p.color : 'green'];
	const hidth = p.h || '7vw';
	const lang = store.settings.language;
	const defSize = `calc(${hidth} * 0.9)`;
	const fontSize = p.fontSize ? (p.fontSize[lang] || p.fontSize.en || defSize) : defSize;
	const getStyleLine = (template, valueName) => {
		let count = -1;
		return template.replace(
			new RegExp(valueName, "g"),
			w => color[valueName].split(',')[++count]
		)
	}

	return `
		--h: 0.5vw; // calc(${hidth} / 20);
		margin-top: calc(3 * var(--h));

		width: ${p.w || 'auto'};

		font-size: ${fontSize} !important;
		line-height: calc(1.2 * ${fontSize});
		text-align: center;
		cursor: ${disabled ? 'initial' : 'pointer'};
		pointer-events: ${disabled ? 'none' : 'inherit'};
		opacity: ${disabled && p.color === 'grey' ? 0.5 : 1};
		position: relative;

		.top {
			height: ${p.h ? hidth : 'auto'};
			font-weight: 800;
			color: ${color.textColor || 'white'};
			text-transform: uppercase;
			text-shadow: 0px calc(0.5 * var(--h)) 0px #00000059;
			padding: calc(3 * var(--h)) calc(2 * var(--h));

			border-radius: calc(3 * var(--h));
			transform: translateY(calc(-2 * var(--h)));
			background-image: linear-gradient(${color.topGrad});
    		box-shadow: ${getStyleLine(schemes.topShadows, 'topShadowColor')};

			position: relative;
			display: flex;
			justify-content: center;
			align-items: center;
		}

		.glow {
			border-radius: calc(3 * var(--h));
			width: 100%; height: 100%;
			position: absolute;
			box-shadow: 0 calc(-0.75 * var(--h)) calc(2.5 * var(--h)) calc(2.5 * var(--h)) white;
		}
		.bottom {
			border-radius: calc(3 * var(--h));
			background-image: linear-gradient(to right, ${color.bottomGrad});
			box-shadow: ${getStyleLine(schemes.bottomShadows, 'bottomShadowColor')};
			transform: translateX(0px);

			&:active .top {
				transform: translateY(calc(-1 * var(--h)));
			}
		}

		.btnIcon {
			max-width: calc(1.5 * ${hidth});
			height: calc(1.2 * ${hidth});
			filter: drop-shadow(0 0.25vw 0 #00000059) ${disabled ? 'grayscale(100%)' : ''};
		}

		.label {
			//border: 1px solid white;
			//flex-grow: 1;
			white-space: pre-wrap;
		}
	`
}}`;

export const IconButton = styled(p => { return (
	<div className={p.className} style={p.style}>
		<ButtonMover onClick={p.onClick}
			onMouseDown={p.onMouseDown} onMouseUp={p.onMouseUp}
		>
			<B64Image alt='button' 
				src={p.localize ? `assets/languages/${store.getLanguage}/${p.src}` : p.src}
			/>
		</ButtonMover>
	</div>
)})`
	position: relative;
	height: ${p => p.h || p.size || 10}vw;
	width: ${p => p.w || p.size || 10}vw;
	img	{	width ${p => p.w || p.size || 10}vw !important;}

	${p => {
		const disabled = p.disable ? p.disable : false;
		return `
			cursor: ${disabled ? 'initial' : 'pointer'};
			pointer-events: ${disabled ? 'none' : 'inherit'};
			filter: drop-shadow(0 0.25vw 0 #00000059) ${disabled ? 'grayscale(100%)' : ''};
		`;
	}}
`;

export const CloseButton = styled(p => {return (
	<IconButton 
		src="/assets/buttons/btn_close.png"
		onClick={p.onClick}
		className={p.className}
	/>
)})`
	position: absolute;
	top: ${p => p.top ? p.top : -3}vw;
	right: ${p => p.right ? p.right : 0}vw;
	height: ${p => p.size ? p.size : 12}vw;
	width: ${p => p.size ? p.size : 12}vw;
	z-index: 20;
	img	{	width: ${p => p.size ? p.size : 12}vw !important;}
`;